import { useEffect, useState } from "react"
import TextArea from './textArea'
import style from '../task-creator.module.css'
import {ru} from "../../../data/ru";
import {by} from "../../../data/by";
export default function QuestionName({change, id,defaultName}) {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdThree : by.RoleIdThree;

    const [name, setName] = useState(defaultName||'')

    function changeHandler(e) {
        setName(e.target.value)
    }

    useEffect(() => {
        setName(defaultName||'')
    }, [id])

    useEffect(() => {
        change(name)
    }, [name])
    return (
        <div className={style.task_line_box}>
            <h2>{language.createTaskQuestionText}</h2>
            <TextArea value={name} placeholder={language.createTaskQuestionText} changeHandler={changeHandler}/>
            {/*<textarea placeholder="Input question" value={name} onChange={(e) => changeHandler(e)}/>*/}
        </div>
    )
}